import React, { useState } from "react";
import Dropdown from "../../elements/Dropdown/Dropdown";
import { Placement } from "@floating-ui/dom";

type Variant = "flat" | "raised" | "simple";

const DropdownSimple = ({
  buttonContent,
  dropdownContent,
  className,
  variant = "raised",
  dropdownWidth,
  placement = "bottom-end",
  hideOnClickInsideDropdown = false,
}: {
  buttonContent: React.ReactNode;
  dropdownContent: React.ReactNode;
  className?: string;
  variant?: Variant;
  dropdownWidth?: number | "auto" | "max-content";
  placement?: Placement;
  hideOnClickInsideDropdown?: boolean;
}): React.JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen((isOpen) => !isOpen);

  const wrappedDropdownContent = (
    <div
      onClick={(e) => {
        e.stopPropagation();
        setIsOpen(false);
      }}
    >
      {dropdownContent}
    </div>
  );

  return (
    <Dropdown
      variant={variant}
      className={className}
      dropdownWidth={dropdownWidth}
      buttonContent={buttonContent}
      isOpen={isOpen}
      toggleOpen={toggleOpen}
      dropdownContent={
        hideOnClickInsideDropdown ? wrappedDropdownContent : dropdownContent
      }
      placement={placement}
    />
  );
};

export default DropdownSimple;
